export default __webpack_public_path__ + "static/char-07-anr-35ad8ae472dadd5983c8fc902d9ab60f.webp";